export const manifest = {
  screens: {
    scr_jl85sl: { name: "Home", route: "/" },
  },
}
